import React from 'react';
import {BackdropStyle} from './BackdropStyle';

interface Props {
    onClick?: () => void;
    transparent?: boolean;
}

export const Backdrop: React.SFC<Props> = props => <BackdropStyle aria-hidden={true} {...props} />;

Backdrop.defaultProps = {
    transparent: false
};

Backdrop.displayName = 'Backdrop';
